import { Chip } from '@mui/material';

interface Props {
  name: string | undefined;
  analyzerId: number;
}

const AnalyzerChip = ({ name, analyzerId }: Props) => {
  return <Chip variant='outlined' label={name} />;
};

export default AnalyzerChip;
